export default __webpack_public_path__ + "static/whatsapp-7f02d15e4c8e6060c3f61371390c8426.png";